module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbx_invo1"
  }, [(!_vm.isNoCard) ? _c('div', {
    style: ({
      height: (_vm.pullHeight - 107) + 'px'
    }),
    attrs: {
      "id": "card"
    }
  }, _vm._l((_vm.fpList), function(item, index) {
    return _c('div', {
      staticClass: "weui_cells vux-no-group-title exp-cell-t2 touch",
      on: {
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.touchStart($event)
        },
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.touchEnd(item.id, $event)
        },
        "touchmove": function($event) {
          $event.stopPropagation();
          return _vm.touchMove($event)
        }
      }
    }, [_c('div', {
      staticClass: "item",
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "weui_cell"
    }, [_c('div', {
      staticClass: "weui_cell_bd"
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.type === 0) ? _c('span', {
      staticClass: "vux-label-desc"
    }, [_vm._v("个人")]) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('span', {
      staticClass: "vux-label-desc"
    }, [_vm._v("单位")]) : _vm._e(), _vm._v(" "), (index === 0) ? _c('x-button', {
      staticClass: "moren-btn",
      attrs: {
        "disabled": _vm.disabled,
        "type": "warn",
        "mini": ""
      }
    }, [_vm._v("默认")]) : _vm._e()], 1), _vm._v(" "), _c('img', {
      staticStyle: {
        "margin-right": "100px"
      },
      attrs: {
        "width": "50px",
        "align": "right",
        "src": 'data:image/png;base64,' + item.cardImg
      },
      on: {
        "click": function($event) {
          return _vm.share(item.cardImg)
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "remove",
      staticStyle: {
        "height": "100%",
        "line-height": "80px"
      },
      attrs: {
        "href": "javascript:"
      },
      on: {
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.deleteItem(index, item.id)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isNoCard) ? _c('div', {
    staticClass: "nocard-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/noCard.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("您还没有添加过发票名片哦~")])]) : _vm._e(), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-demo",
    attrs: {
      "scroll": false,
      "hide-on-blur": "hideOnBlur"
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": 'data:image/png;base64,' + _vm.showImg
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.isShow = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/addCard/')
      }
    }
  }, [_vm._v("添加发票名片")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": "3000"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))]), _vm._v(" "), _c('confirm', {
    staticClass: "zzz",
    attrs: {
      "on-hide": "onHide"
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow
    },
    model: {
      value: (_vm.confirmStatus),
      callback: function($$v) {
        _vm.confirmStatus = $$v
      },
      expression: "confirmStatus"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px",
      "color": "#333",
      "font-size": "16px",
      "font-weight": "bold",
      "height": "1.3em"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "margin-right": "10px",
      "vertical-align": "middle",
      "margin-top": "-1px"
    },
    attrs: {
      "src": require("../../assets/img/tit.png")
    }
  }), _vm._v("确认要删除该名片吗？")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9e55ad4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/invoiceCard.vue
// module id = 348
// module chunks = 0